<div class="task-details" fxLayout="column" fxFlex="100" fxLayoutAlign="start start">
    <div style="font-size: 13px;color: #808080;">
        <span (click)="goBack()" style="color: #228BE6;font-size: 13px;cursor: pointer;">All Tasks </span> /
        {{taskId}}
    </div>
    <div class="task-details__header width_100" fxLayoutAlign="space-between">
        <div class="task-details__header-status" [ngClass]="taskDetail?.priority">
            {{taskDetail?.priority}}
        </div>
    </div>
    <form [formGroup]="orderDetailsForm" class="task-details__main" fxLayout="column" fxLayoutGap="20px"
        fxLayoutAlign="center start">
        <div fxLayout="row" class="task-details__main-info width_100">
            <div fxFlex="100" fxLayout="column">
                <div class="task-details__main-info-row width_100" fxLayoutAlign="start center">
                    <div class="task-details__main-info-label"
                        fxFlex="{{globalService.isMobile$.getValue() ? 35 : 25}}">
                        Task Status</div>

                    <div class="task-details__main-info-select active" fxLayout="row"
                        fxLayoutAlign="space-between center" [matMenuTriggerFor]="menu" #t="matMenuTrigger"
                        [ngClass]="taskDetail?.statusName=='In work'?'In-Work':taskDetail?.statusName">
                        <div>{{globalService.getDisplayStatus(taskDetail?.statusName)}}</div>
                        <mat-icon [class.rotated]="t.menuOpen" [svgIcon]="'arrow-down'"></mat-icon>
                    </div>

                    <mat-menu #menu="matMenu" class="task-details-status" yPosition="below">
                        <div class="menu-option" (click)="changeStatus(item)"
                            *ngFor="let item of statusOptions; let i = index">
                            <div class="task-details__main-info-select" fxLayout="row"
                                fxLayoutAlign="space-between center"
                                [ngClass]="item?.text=='In work'?'In-Work':item?.text">
                                <div>{{globalService.getDisplayStatus(item.text)}}</div>
                            </div>
                        </div>
                    </mat-menu>
                </div>
                <button class="viewDetails" (click)="editTask()">Edit/Escalate Task</button>

                <div class="task-details__main-info-row width_100" fxLayoutAlign="start center">
                    <div class="task-details__main-info-label"
                        fxFlex="{{globalService.isMobile$.getValue() ? 35 : 25}}">
                        Due Date</div>

                    <div class="task-details__main-info-value"
                        [ngStyle]="{ 'color': isOverdue() && taskDetail?.statusName!='Closed' ? '#D9480F' : '' }">
                        {{taskDetail?.toBeDoneBy | date:'dd/MM/yyyy'}}</div>
                </div>

                <div class="task-details__main-info-row width_100" fxLayoutAlign="start center">
                    <div class="task-details__main-info-label"
                        fxFlex="{{globalService.isMobile$.getValue() ? 35 : 25}}">
                        Created By</div>

                    <div class="task-details__main-info-value">{{taskDetail?.createdBy}}</div>
                </div>

                <div class="task-details__main-info-row width_100" fxLayoutAlign="start center">
                    <div class="task-details__main-info-label"
                        fxFlex="{{globalService.isMobile$.getValue() ? 35 : 25}}">
                        Date & Time Created</div>

                    <div class="task-details__main-info-value">
                        {{taskDetail?.createdFormatted }}
                    </div>
                </div>
            </div>
            <div fxFlex="100" fxLayout="column">
                <div class="task-details__main-info-row width_100" fxLayoutAlign="start center">
                    <div class="task-details__main-info-label"
                        fxFlex="{{globalService.isMobile$.getValue() ? 35 : 25}}">
                        Responsible Person</div>

                    <div class="task-details__main-info-value">{{taskDetail?.responsiblePersonName }}</div>
                </div>
                <div class="task-details__main-info-row width_100" fxLayoutAlign="start center">
                    <div class="task-details__main-info-label"
                        fxFlex="{{globalService.isMobile$.getValue() ? 35 : 25}}">
                        Department</div>

                    <div class="task-details__main-info-value"
                        *ngIf="taskDetail?.departmentName != '' && taskDetail?.departmentName != null; else elseBlock">
                        {{
                        taskDetail?.departmentName === 'Other' ||
                        taskDetail?.departmentName === 'Others'
                        ? 'Pending Assignment'
                        : taskDetail?.departmentName
                        }}
                    </div>

                    <ng-template #elseBlock>
                        <div class="task-details__main-info-value">
                            Pending Assignment
                        </div>
                    </ng-template>

                </div>
                <div class="task-details__main-info-row width_100" fxLayoutAlign="start center">
                    <div class="task-details__main-info-label"
                        fxFlex="{{globalService.isMobile$.getValue() ? 35 : 25}}">
                        Priority</div>
                    <div class="task-details__main-info-value">{{taskDetail?.priority}}
                    </div>
                </div>
                <div class="task-details__main-info-row width_100" fxLayoutAlign="start center">
                    <div class="task-details__main-info-label"
                        fxFlex="{{globalService.isMobile$.getValue() ? 35 : 25}}">
                        Escalated</div>
                    <div class="task-details__main-info-value"><svg *ngIf="taskDetail?.isEscalate==false"
                            xmlns="http://www.w3.org/2000/svg" width="11.915" height="14.409"
                            viewBox="0 0 11.915 14.409" style="margin-right: 5px;">
                            <path id="flag-variant"
                                d="M5.794,3a.8.8,0,0,1,.794.8v.7a8.464,8.464,0,0,1,3.177-.7c2.383,0,2.383,1.6,3.972,1.6a3.438,3.438,0,0,0,3.177-1.6v6.4a3.438,3.438,0,0,1-3.177,1.6c-2.383,0-2.383-1.6-3.972-1.6a3.438,3.438,0,0,0-3.177,1.6v5.6H5V3.8A.8.8,0,0,1,5.794,3Z"
                                transform="translate(-5 -3)" fill="#00be26" />
                        </svg>
                        <svg *ngIf="taskDetail?.isEscalate==true" xmlns="http://www.w3.org/2000/svg" width="11.915"
                            height="14.409" viewBox="0 0 11.915 14.409" style="margin-right: 5px;">
                            <path id="flag-variant"
                                d="M5.794,3a.8.8,0,0,1,.794.8v.7a8.464,8.464,0,0,1,3.177-.7c2.383,0,2.383,1.6,3.972,1.6a3.438,3.438,0,0,0,3.177-1.6v6.4a3.438,3.438,0,0,1-3.177,1.6c-2.383,0-2.383-1.6-3.972-1.6a3.438,3.438,0,0,0-3.177,1.6v5.6H5V3.8A.8.8,0,0,1,5.794,3Z"
                                transform="translate(-5 -3)" fill="#d9480f" />
                        </svg>{{getvalueEscalate(taskDetail?.isEscalate)}}
                    </div>
                </div>
            </div>

        </div>
        <!-- 
        <div class="task-details__main-note width_100" fxLayoutGap="5px" fxLayout="column" fxLayoutAlign="start start">
            <mat-label>Note/Remarks</mat-label>
            <mat-form-field class="width_100 disabled-color" appearance="outline">
                <textarea matInput placeholder="No note/remarks" formControlName="note"></textarea>
            </mat-form-field>
        </div> -->
        <div class="task-details__main-note width_100" fxLayoutGap="10px" fxLayout="column" fxLayoutAlign="start start">
            <div class="task-details__main-info-label">Task Description</div>
            <div fxLayout="column" fxFlex="100" class="width_100 task-details__main-info-value"
                style="font-weight: 500;color: #495057;">
                {{taskDetail?.taskName}}
            </div>
            <div class="task-details__main-info-value">{{taskDetail?.description}}</div>
        </div>
        <div class="task-details__main-note width_100" fxLayoutGap="10px" fxLayout="column" fxLayoutAlign="start start">
            <div class="task-details__main-info-label">Location Details</div>
            <div class="task-details__main-info-value">{{taskDetail?.location}}</div>
        </div>
        <div class="task-details__main-note width_100" fxLayoutGap="5px" fxLayout="column" fxLayoutAlign="start start">
            <div class="task-details__main-info-label" fxLayout="column">Photos</div>
            <div fxLayout="row" *ngIf="uploadResults?.length!=0">
                <div *ngFor="let item of uploadResults" class="p-2" fxLayout="column" style="margin-right: 10px;">
                    <img [src]="item.base64" alt="{{ item.displayname }}"
                        (click)="openImage(item.base64, item.displayname)"
                        style="max-width: 200px;width:80px;height:80px; border-radius: 8px; box-shadow: 0 2px 4px rgba(0,0,0,0.1);" />
                </div>
            </div>
            <div *ngIf="uploadResults?.length==0">-</div>
            <!-- <div><img src="../../../assets/images/png/menu/cheese.png">
                <img src="../../../assets/images/png/menu/chorizo.png">
                <img src="../../../assets/images/png/menu/margarita.png">
            </div> -->
        </div>
        <!-- Image Popup -->
        <div class="image-modal" *ngIf="showImageModal" (click)="closeImage()">
            <div class="image-modal-content" (click)="$event.stopPropagation()">
                <span class="close-btn" (click)="closeImage()">&times;</span>

                <img [src]="selectedImage" [alt]="selectedImageName" class="full-image" />

                <div class="image-name">{{ selectedImageName }}</div>
            </div>
        </div>
    </form>
    <div class="task-details__text" fxLayout="column" fxLayoutAlign="center start" *ngIf="taskDetail?.isEscalate==true">
        <div class="task-details__main-info-label greyBackground" style="color:#d9480f ;" fxLayout="row">Escalation
            Details</div>
        <div fxLayout="column" fxFlex="100" class="width_100 task-details__main-info-value"
            style="font-weight: 500;padding: 20px;color: #495057;">
            {{taskDetail?.escalationReason}}
        </div>
        <div fxLayout="column" fxFlex="100" *ngIf="taskDetail?.remarks!='' && taskDetail?.remarks!=null"
            style="padding: 0px 20px 20px 20px;" class="width_100 task-details__main-info-value">
            {{taskDetail?.remarks}}
        </div>
        <div fxLayout="column" fxFlex="100" *ngIf="taskDetail?.remarks=='' || taskDetail?.remarks==null"
            style="padding: 0px 20px 20px 20px;" class="width_100 task-details__main-info-value">
            -
        </div>
    </div>
    <div class="task-details__text" fxLayout="column" fxLayoutAlign="center start">
        <div class="task-details__main-info-label greyBackground" fxLayout="row">Note/Remarks</div>

        <div fxLayout="column" fxFlex="100" class="width_100 textPadding">
            <textarea matInput class="task-details__main" style="font-family: 'Roboto', sans-serif !important;"
                placeholder="Write your note/remarks here." [value]="originalText"
                (input)="originalText = $event.target.value;onEdit()"></textarea>
        </div>

        <!-- Show Save/Cancel only when editing -->
        <div class="create-task__summary" fxLayout="row" fxLayoutAlign="end end" *ngIf="isEdit">
            <div class="create-task__summary-actions" fxLayoutAlign="end center">
                <div mat-ripple class="create-task__summary-clear cursor_pointer" (click)="onCancel()">
                    Cancel
                </div>
                <div mat-ripple class="create-task__summary-show cursor_pointer" (click)="onSubmit($event)"
                    type="submit">
                    Save
                </div>
            </div>
        </div>
        <div fxLayout="column" fxFlex="100" class="width_100 remarks" *ngFor="let comment of taskComments">
            <div fxLayout="column" class="task-details__main-info-label title">
                {{comment.creator}}
            </div>
            <div fxLayout="column" class="task-details__main-info-value value">
                {{comment.date | date:'dd/MM/yyyy, HH:mm a'}}
            </div>
            <!-- <div fxLayout="column" class="task-details__main-info-value">{{comment.text}}</div> -->
            <div fxLayout="column" class="task-details__main-info-value">

                <!-- Normal text when NOT editing -->
                <div *ngIf="editCommentId !== comment.id">
                    {{ comment.text }}
                </div>

                <!-- Textarea when editing THIS comment -->
                <textarea matInput class="task-details__main" style="margin-bottom: 10px;"
                    *ngIf="editCommentId === comment.id" [(ngModel)]="editText" rows="3"></textarea>

            </div>
            <div fxLayout="row" style="padding: 10px 0px;" *ngIf="editCommentId !== comment.id">
                <div style="color: #228BE6;margin-right: 10px;font-size: 12px;cursor: pointer;"
                    (click)="onEditComment(comment)">
                    Edit
                </div>

                <div style="color: #808080;font-size: 12px;cursor: pointer;" (click)="onDelete(comment)">
                    Delete
                </div>
            </div>

            <!-- SAVE / CANCEL only for this comment -->
            <div class="create-task__summary-actions" fxLayoutAlign="end center" *ngIf="editCommentId === comment.id">
                <div mat-ripple class="create-task__summary-clear cursor_pointer" (click)="onCancelEdit()">
                    Cancel
                </div>
                <div mat-ripple class="create-task__summary-show cursor_pointer" (click)="onSaveComment()"
                    type="submit">
                    Save
                </div>
            </div>
        </div>
    </div>

    <!-- <div class="task-details__text" fxLayout="column" fxLayoutAlign="center start">
        <div class="task-details__main-info-label greyBackground">Activity Log</div>
        <mat-radio-group fxLayout="column" class="radios" fxFlex="100">
            <mat-radio-button class="task-details__main-info-value">
                To Do
            </mat-radio-button>
            <mat-radio-button class="task-details__main-info-value">
                29/09/2025, 11:30 AM: Task created by Huber, Cessy
            </mat-radio-button>
        </mat-radio-group>
    </div> -->
</div>

<!-- <ng-template #dialogTemplate>
    <div class="eventViewpanle" #dialogTemplate>
        <div class="event_title">
            <div class="event_description_details">
                <div class="event_description_details_icon_right">
                    <div style="color: #495057;font-size: 14px; font-weight: 500;">
                        {{getServiceName(selectedEvent.serviceType)}}</div>
                    <div style="color: #868E96;font-size: 10px;" class="event_description_details_title">Reference No.
                        {{selectedEvent.referenceNo}}</div>
                </div>
            </div>
            <div class="event_description_details">
                <div class="event_description_details_icon_right">
                    <div style="color: #868E96;font-size: 10px;text-align: end;"
                        class="event_description_details_title">Amount Due</div>
                    <div style="background-color: #FFE9E0;padding: 5px;color: #FF3333;font-size: 14px;font-weight: 500;border-radius: 5px;"
                        class="event_description_details_value">{{taskDetail?.transactionStatus ===
                        'completed'?(selectedEvent.amountDue| number:'1.2-2'):selectedEvent.price || '0,00'}}
                        {{globalService.currency}}</div>
                </div>
            </div>
        </div>
        <div class="event_description">
            <div class="event_description_left">
                <div class="event_description_details">
                    <div class="event_description_details_icon">
                        <img src="../../../assets/images/map-legend.svg" alt="">
                    </div>
                    <div class="event_description_details_icon_right">
                        <div class="event_description_details_title">Service Type</div>
                        <div class="event_description_details_value"
                            style="color: #495057;font-size: 13px;font-weight: 500;padding-top: 5px;">
                            {{getServiceName(selectedEvent.serviceType)}}</div>
                    </div>
                </div>

                <div class="event_description_details">
                    <div class="event_description_details_icon">
                        <img src="../../../assets/images/car-back.svg" alt="">
                    </div>
                    <div class="event_description_details_icon_right">
                        <div class="event_description_details_title">Vehicle</div>
                        <div class="event_description_details_value"
                            style="color: #495057;font-size: 13px;font-weight: 500;padding-top: 5px;">
                            {{selectedEvent.vehicle}}</div>
                    </div>
                </div>

                <div class="event_description_details">
                    <div class="event_description_details_icon">
                        <img src="../../../assets/images/spacalendar.svg" alt="">
                    </div>
                    <div class="event_description_details_icon_right">
                        <div class="event_description_details_title">Pickup Date & Time</div>
                        <div class="event_description_details_value"
                            style="color: #495057;font-size: 13px;font-weight: 500;padding-top: 5px;">
                            {{formatDate(selectedEvent.pickupDate)}}
                        </div>
                    </div>
                </div>

            </div>
            <div class="event_description_right">
                <div class="event_description_details">
                    <div class="event_description_details_icon">
                        <img src="../../../assets/images/compass-outline.svg" alt="">
                    </div>
                    <div class="event_description_details_icon_right">
                        <div class="event_description_details_title">Service Provider</div>
                        <div class="event_description_details_value"
                            style="color: #495057;font-size: 13px;font-weight: 500;padding-top: 5px;"
                            [ngStyle]="{'opacity': selectedEvent.serviceProvider ? '1' : '0'}">
                            {{selectedEvent.serviceProvider?selectedEvent.serviceProvider:'Service Provider'}}</div>
                    </div>
                </div>
                <div class="event_description_details">
                    <div class="event_description_details_icon">
                        <img src="../../../assets/images/people-group-outline.svg" alt="">
                    </div>
                    <div class="event_description_details_icon_right">
                        <div class="event_description_details_title">No. Of Passengers</div>
                        <div class="event_description_details_value "
                            style="color: #495057;font-size: 13px;font-weight: 500;padding-top: 5px;">
                            {{selectedEvent.noOfPassengers}}</div>
                    </div>
                </div>
                <div class="event_description_details">
                    <div class="event_description_details_icon">
                        <img src="../../../assets/images/spaperson.svg" alt="">
                    </div>
                    <div class="event_description_details_icon_right">
                        <div class="event_description_details_title">Passenger Name</div>
                        <div class="event_description_details_value"
                            style="color: #495057;font-size: 13px;font-weight: 500;padding-top: 5px;">
                            {{selectedEvent.lastName}}
                            {{selectedEvent.firstName}}</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="locations">
            <div class="event_description_details" style="display: flex;justify-content: center;">
                <div class="event_description_details_icon_right">
                    <div class="event_description_details_value"
                        style="color: #495057;font-size: 14px;font-weight: 500;padding-top: 5px;">
                        {{selectedEvent.pickupLocation}}</div>
                    <div class="event_description_details_title">
                        {{selectedEvent.pickupLocationAddress}}</div>
                </div>
            </div>
            <div class="event_description_details_icon">
                <img src="../../../assets/images/arrow-up.svg" alt="">
            </div>
            <div class="event_description_details" style="display: flex;justify-content: center;">
                <div class="event_description_details_icon_right">
                    <div class="event_description_details_value"
                        style="color: #495057;font-size: 14px;font-weight: 500;padding-top: 5px;">
                        {{selectedEvent.dropOffLocation}}</div>
                    <div class="event_description_details_title">
                        {{selectedEvent.dropOffLocationAddress}}</div>
                </div>
            </div>
        </div>

        <div class="event_description_details">
            <div class="event_description_details_icon">
                <img src="../../../assets/images/spanote.svg" alt="">
            </div>
            <div class="event_description_details_icon_right">
                <div class="event_description_details_title">Note</div>
                <div class="event_description_details_value"
                    style="color: #495057;font-size: 13px;font-weight: 500;padding-top: 5px;">
                    {{selectedEvent.note}}</div>
            </div>
        </div>
        <div class="event_buttons">
            <a (click)="onClose()" class="close_button">Close</a>
            <a (click)="onDeleteEvent()"
                [ngClass]="taskDetail?.transactionStatus == 'open' ? 'delete_button' : 'delete_buttonDisabled'">Cancel
                Request</a>
            <a (click)="onEditEvent()"
                [ngClass]="taskDetail?.transactionStatus == 'open' ? 'edit_button' : 'editDisabled'">Edit</a>
        </div>
    </div>

</ng-template> -->